import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, AlertCircleIcon, TargetIcon, ActivityIcon, RefreshCwIcon } from 'lucide-react';
import { problems, Problem } from '../data/content';
const icons: Record<Problem['icon'], typeof BrainIcon> = {
  brain: BrainIcon,
  alert: AlertCircleIcon,
  target: TargetIcon,
  activity: ActivityIcon,
  refresh: RefreshCwIcon
};
export function Problems() {
  return <section className="w-full py-12 sm:py-16" aria-labelledby="problemas-title" data-id="element-159" data-mp="2t55otncx5828">
      <div className="mx-auto max-w-6xl px-6" data-id="element-160" data-mp="2o503eox8shsl">
        <div className="mx-auto max-w-2xl text-center" data-id="element-161" data-mp="2o7cmx6inf07r">
          <h2 id="problemas-title" className="font-display text-3xl font-semibold tracking-tight text-tinta sm:text-4xl" data-id="element-162" data-mp="2j781d22vvfao">
            ¿Te pasa alguna de estas situaciones?
          </h2>
          <p className="mt-4 text-lg leading-snug text-tinta/65" data-id="element-163" data-mp="hf3fa782fc7v">
            Cuando llega el partido, no falla tu cuerpo: falla tu cabeza.
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-164" data-mp="34quz69c366eo">
          {problems.map((problem, index) => {
          const Icon = icons[problem.icon];
          return <motion.article key={problem.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.45,
            delay: index * 0.06
          }} className="rounded-4xl border border-salvia/40 bg-white p-7 shadow-soft transition-shadow duration-300 hover:shadow-lift" data-id="element-165" data-mp="39r99xz52nuge" data-mpi={index}>
                <span className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-salvia/25 text-bosque" data-id="element-166" data-mp="3epkjs9vda4ym">
                  <Icon className="h-6 w-6" strokeWidth={1.6} aria-hidden="true" data-id="element-167" data-mp="3ipkzryy46o7s" />
                </span>
                <h3 className="font-display text-xl font-semibold text-tinta" data-id="element-168" data-mp="aa18v6kx1hvw">
                  {problem.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-tinta/65" data-id="element-169" data-mp="f3dvjb61bem0">
                  {problem.text}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}